import { lazy } from "react";
import Layout from "../layout";
import { Navigate, useRoutes } from "react-router-dom";
import { QuestionnaireAnalytics } from "../components/account/clinical/questionnaire-analytics";
import ClinicalLayout from "../layout/clinical";
import LoggedOut from "../components/loggedout";

const Home = lazy(() => import("../components/home"));
const Discover = lazy(() => import("../components/discover"));
const Planning = lazy(() => import("../components/planning"));
const Compare = lazy(() => import("../components/compare"));
const Understand = lazy(() => import("../components/understand"));
const Login = lazy(() => import("../components/account/login"));
const ClinicalLogin = lazy(
  () => import("../components/account/login/clinical")
);
const Profile = lazy(() => import("../components/account/"));
const Reviews = lazy(() => import("../components/reviews/"));
const Privacy = lazy(() => import("../components/privacy-policy/"));
const Disclaimer = lazy(() => import("../components/disclaimer/"));
const Favourites = lazy(() => import("../components/account/favourites"));
const VASQOL = lazy(() => import("../components/forms/vasqol"));
const OtherForms = lazy(() => import("../components/forms/other"));
const TakeForm = lazy(() => import("../components/forms/take"));
const CMSPage = lazy(() => import("../components/cms-page"));
const VirtualArm = lazy(() => import("../components/tools/virtual-arm/"));

const useRenderRoutes = () =>
  useRoutes([
    {
      element: <Layout />,
      children: [
        { index: true, element: <Home /> },
        { path: "discover", element: <Discover /> },
        { path: "planning", element: <Planning /> },
        { path: "compare", element: <Compare /> },
        { path: "understand/:slug", element: <Understand /> },
        { path: "reviews", element: <Reviews /> },
        { path: "account/login", element: <Login /> },
        { path: "account/login/clinical", element: <ClinicalLogin /> },
        {
          path: "account/clinical/questionnaire-analytics",
          element: <QuestionnaireAnalytics />,
        },
        { path: "account/profile", element: <Profile /> },
        { path: "account/favourites", element: <Favourites /> },
        { path: "documents/privacy-policy", element: <Privacy /> },
        { path: "documents/disclaimer", element: <Disclaimer /> },
        { path: "other-questionnaires", element: <OtherForms /> },
        { path: "forms/:slug", element: <VASQOL /> },
        { path: "forms/:slug/take", element: <TakeForm /> },
        { path: "tools/virtual-arm", element: <VirtualArm /> },
        { path: ":slug", element: <CMSPage /> },
        { path: ":slug/:slug2", element: <CMSPage /> },
        { path: ":slug/:slug2/:slug3", element: <CMSPage /> },
        { path: ":slug/:slug2/:slug3/:slug4", element: <CMSPage /> },
        {
          path: "account/clinical/questionnaire-analytics",
          element: <QuestionnaireAnalytics />,
        },
        { path: "logged-out", element: <LoggedOut /> },
      ],
    },
    {
      path: "*",
      element: <Navigate to="/" replace />,
    },
  ]);

const renderRoutes = { useRenderRoutes };

export default renderRoutes;
